<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";
import { useImage, useUploadImage } from "@/hooks";
const props = defineProps<{
  modelValue?: string;
  src?: string;
}>();

const { imageUrl } = useUploadImage(computed(() => props.modelValue));
const { imageUrl: bgUrl } = useImage(computed(() => props.src));
</script>
<template>
  <PreviewableImage
    class="mp-uploaded-image"
    :src="imageUrl || bgUrl"
    v-bind="$attrs"
  />
</template>
